import React, { useContext } from 'react'
import Messages from './Messages'
import Input from './Input'
import { ChatContext } from '../context/ChatContext'

const Chatbar = () => {
  const { data } = useContext(ChatContext)

  return (
    <div className='chat-area'>
      <div className="chat-area__header">
        <div className="chat-area__header-info">
          {data.user?.photoURL ? (
            <img src={data.user.photoURL} alt='' className="chat-area__header-avatar" />
          ) : (
            <div className="chat-area__header-avatar-placeholder"></div>
          )}
          <div className="chat-area__header-details">
            <span className="chat-area__header-name">{data.user?.displayName || "Select a chat"}</span>
            {data.user?.displayName && (
              <span className="chat-area__header-status">
                <span className="status-dot"></span> Online
              </span>
            )}
          </div>
        </div>
        
        {data.user?.displayName && (
          <div className="chat-area__header-actions">
            <button className="action-btn" title="Video Call">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15 10L21 6V18L15 14V10Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <rect x="3" y="6" width="12" height="12" rx="2" stroke="currentColor" strokeWidth="1.5" />
              </svg>
            </button>
            <button className="action-btn" title="Add User">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16 21V19C16 16.7909 14.2091 15 12 15H5C2.79086 15 1 16.7909 1 19V21" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <circle cx="8.5" cy="7" r="4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M20 8V14M17 11H23" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </button>
            <button className="action-btn" title="More Options">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="1.5" fill="currentColor" />
                <circle cx="12" cy="5" r="1.5" fill="currentColor" />
                <circle cx="12" cy="19" r="1.5" fill="currentColor" />
              </svg>
            </button>
          </div>
        )}
      </div>     
      
      <Messages />
      <Input /> 
    </div>
  )
}

export default Chatbar;